import React, { useState } from "react";
import { Field, useFormSubmit, FormFooter } from "./_shared";

export default function ShowingPrefsForm({ onSubmitted }) {
  const [f, setF] = useState({
    approval_mode: "Send for approval",
    advance_notice: "2 hours",
    showing_window: "9am–7pm daily",
    notify_email: true,
    notify_text: true,
    notify_phone: "",
    instructions: "",
  });
  const upd = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const { submit, busy, err } = useFormSubmit("showing_preferences");

  return (
    <form onSubmit={(e) => { e.preventDefault(); submit(f, onSubmitted); }} className="card" style={{ padding: 32, display: "flex", flexDirection: "column", gap: 20 }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 20 }}>
        <Field label="Approval mode">
          <select data-testid="showing-approval" className="input-field" value={f.approval_mode} onChange={upd("approval_mode")}>
            <option>Send for approval</option>
            <option>Automatically accept</option>
          </select>
        </Field>
        <Field label="Advance notice">
          <select data-testid="showing-notice" className="input-field" value={f.advance_notice} onChange={upd("advance_notice")}>
            <option>No minimum</option>
            <option>1 hour</option>
            <option>2 hours</option>
            <option>4 hours</option>
            <option>24 hours</option>
          </select>
        </Field>
        <Field label="Showing window">
          <input data-testid="showing-window" className="input-field" value={f.showing_window} onChange={upd("showing_window")} />
        </Field>
        <Field label="Phone for text notifications">
          <input data-testid="showing-phone" className="input-field" value={f.notify_phone} onChange={upd("notify_phone")} placeholder="(555) 555-5555" />
        </Field>
      </div>

      <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
        <label style={{ display: "flex", alignItems: "center", gap: 8 }}><input data-testid="notify-email-toggle" type="checkbox" checked={f.notify_email} onChange={upd("notify_email")} style={{ accentColor: "var(--primary)" }} /> Email notifications</label>
        <label style={{ display: "flex", alignItems: "center", gap: 8 }}><input data-testid="notify-text-toggle" type="checkbox" checked={f.notify_text} onChange={upd("notify_text")} style={{ accentColor: "var(--primary)" }} /> Text notifications</label>
      </div>

      <Field label="Special instructions (pets, alarms, parking…)">
        <textarea data-testid="showing-instructions" className="input-field" rows={4} value={f.instructions} onChange={upd("instructions")} />
      </Field>

      <FormFooter busy={busy} err={err} testid="showing" />
    </form>
  );
}
